import React, { useEffect, useState } from "react";
import {
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  Box,
  Typography,
  Tooltip,
} from "@mui/material";
import { saveAs } from "file-saver";
import * as base64 from 'base64-js';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const DepositFee = () => {
  const [isMaster, setIsMaster] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(1);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [ddlClass, setDdlClass] = useState([]);
  const [ddlSection, setDdlSection] = useState([]);
  const [ddlStudent, setDdlStudent] = useState([]);
  const [ddlClassType, setDdlClassType] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedClassType, setSelectedClassType] = useState("");
  const [classType, setClassType] = useState("allclass");
  const [sectionType, setSectionType] = useState("allSection");
  const [studentType, setStudentType] = useState("allStudent");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportData, setReportData] = useState(null);
  const [schoolData, setSchoolData] = useState([]);


  const fetchBranches = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const data = await response.json();
        setBranches(data);
      } else {
        console.error("Failed to fetch branches");
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };


  const getFirstDayOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .split("T")[0];
  };

  const getCurrentDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  useEffect(() => {
    setFromDate(getFirstDayOfMonth());
    setToDate(getCurrentDate());
  }, []);

  const fetchSchoolDetails = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/FeeReport/GetSchoolName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setSchoolData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDdlClassType = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/CreateClass/ddlClassType`;
      const token = sessionStorage.getItem("token");
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setDdlClassType(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDdlClass = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setDdlClass(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDdlSection = async (classId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Exam/ddlSection_clsId`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ classId, teacherId: 0 }),
      });
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setDdlSection(data?.data === null ? [] : data);
    } catch (error) {
      console.error(error);
      setDdlSection([]);
    }
  };

  // FIX: previously this required BOTH a class and a section to be picked
  // before it would fetch students. Since "All Section" is the default,
  // the student dropdown would silently stay empty even after picking a
  // class + "Select Student". Now it fetches as soon as a class is chosen,
  // passing sectionId = 0 (meaning "all sections") when no specific
  // section has been selected — and gives proper feedback on failure,
  // matching the behavior in GenerateFee.
  const fetchDdlStudent = async (classId, sectionId) => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/FeeReport/ddlStudentbyClassId`;
      const token = sessionStorage.getItem("token");
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ classId, sectionId }),
      });
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      if (Array.isArray(data)) {
        setDdlStudent(data);
      } else {
        setDdlStudent([]);
        setSnackbarMessage(data?.msg || "No students found for this selection!");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error(error);
      setDdlStudent([]);
      setSnackbarMessage("An error occurred while fetching students!");
      setOpenSnackbar(true);
    }
  };

  useEffect(() => {
    const isMasterUser = sessionStorage.getItem("is_Master") === "true";
    setIsMaster(isMasterUser);

    if (isMasterUser) {
      fetchBranches();
    } else {
      const branchId = sessionStorage.getItem("branchId");
      setSelectedBranchId(branchId);
    }
  }, []);

  useEffect(() => {
    fetchSchoolDetails();
    fetchDdlClass();
    fetchDdlClassType();
  }, []);

  // Fetch (or clear) sections whenever the selected class changes
  useEffect(() => {
    if (selectedClass) {
      fetchDdlSection(selectedClass);
    } else {
      setDdlSection([]);
    }
  }, [selectedClass]);

  // Fetch (or clear) students as soon as a class is selected.
  // If no specific section has been chosen, pass 0 to fetch students
  // across all sections of that class.
  useEffect(() => {
    if (selectedClass) {
      fetchDdlStudent(selectedClass, selectedSection || 0);
    } else {
      setDdlStudent([]);
      setSelectedStudent("");
    }
  }, [selectedClass, selectedSection]);

  const handleClassChange = (event) => {
    setSelectedClass(event.target.value);
    setSelectedSection("");
    setSelectedStudent("");
  };

  const handleSectionChange = (event) => {
    setSelectedSection(event.target.value);
    setSelectedStudent("");
  };

  const handleStudentChange = (event) => setSelectedStudent(event.target.value);
  const handleClassTypeDropdownChange = (event) =>
    setSelectedClassType(event.target.value);

  // Reset the cascade whenever a radio switches back to "all"
  const handleClassTypeChange = (event) => {
    const value = event.target.value;
    setClassType(value);
    if (value === "allclass") {
      setSelectedClass("");
      setSelectedSection("");
      setSelectedStudent("");
      setDdlSection([]);
      setDdlStudent([]);
    }
  };

  const handleSectionTypeChange = (event) => {
    const value = event.target.value;
    setSectionType(value);
    if (value === "allSection") {
      setSelectedSection("");
      setSelectedStudent("");
    }
  };

  const handleStudentTypeChange = (event) => {
    const value = event.target.value;
    setStudentType(value);
    if (value === "allStudent") {
      setSelectedStudent("");
    }
  };

  const handleFromDateChange = (event) => setFromDate(event.target.value);
  const handleToDateChange = (event) => setToDate(event.target.value);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const generateReport = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
      const apiUrl = `${url}/FeeReport/ReportFeePayment?Branch_Id=${branchId}`;
      const token = sessionStorage.getItem("token");

      const formattedFromDate = formatDate(fromDate);
      const formattedToDate = formatDate(toDate);

      const requestBody = {
        isAllClass: classType === "allclass",
        isAllSection: sectionType === "allSection",
        isAllStudent: studentType === "allStudent",
        classId: selectedClass ? parseInt(selectedClass) : 0,
        sectionId: selectedSection ? parseInt(selectedSection) : 0,
        studentId: selectedStudent ? parseInt(selectedStudent) : 0,
        classTypeId: selectedClassType ? parseInt(selectedClassType) : 0,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        setSnackbarMessage('Error: Please provide proper input!');
        setOpenSnackbar(true);
        return;
      }

      const data = await response.json();
      if (data.msg === "Record Not Found") {
        setSnackbarMessage('No records found!');
        setOpenSnackbar(true);
        return;
      }

      setReportData(data);

      // Fetch logo data
      let logoDataUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBgYAAAAAUAAY+SkSAAAAAASUVORK5CYII=';
      let logoLoadError = false;

      try {
        const logoResponse = await fetch(`${process.env.REACT_APP_BASE_URL}/Branch/GetBranch`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
          },
          body: JSON.stringify({}),
        });

        if (!logoResponse.ok) {
          console.error(`Logo API fetch failed: ${logoResponse.status} ${logoResponse.statusText}`);
          throw new Error(`Logo API error: ${logoResponse.status} ${logoResponse.statusText}`);
        }

        const logoApiData = await logoResponse.json();
        const bytLogo = logoApiData?.[0]?.bytLogo;

        if (!bytLogo || typeof bytLogo !== 'string' || bytLogo.trim() === '') {
          console.warn("No valid logo image found in API response");
          throw new Error("Invalid or missing bytLogo in API response");
        }

        // Clean and validate base64
        let cleanedBase64 = bytLogo.replace(/\s/g, '').replace(/\n/g, '');
        const paddingLength = (4 - (cleanedBase64.length % 4)) % 4;
        cleanedBase64 += '='.repeat(paddingLength);

        const isValidBase64 = /^[A-Za-z0-9+/=]+$/.test(cleanedBase64);
        if (!isValidBase64) {
          console.error('Invalid base64 string for bytLogo:', cleanedBase64.substring(0, 100) + '...');
          throw new Error('Invalid base64 string for bytLogo');
        }

        logoDataUrl = `data:image/jpeg;base64,${cleanedBase64}`;

        // Validate the logo image
        const img = new Image();
        await new Promise((resolve, reject) => {
          img.onload = () => {
            console.log("API logo loaded successfully");
            resolve();
          };
          img.onerror = () => {
            console.error("Failed to load API logo image");
            reject(new Error('Failed to load API logo image'));
          };
          img.src = logoDataUrl;
        });

      } catch (error) {
        console.error('Error fetching or processing logo:', error.message);
        logoLoadError = true;
      }

      const reportWindow = window.open("", "_blank");
      reportWindow.document.write(`
      <html>
        <head>
          <title>Fee Payment Report</title>
          <style>
            body {
              font-family: 'Segoe UI', Arial, sans-serif;
              margin: 20px;
              background-color: #f5f5f5;
              color: #333;
            }
            .form-container {
              max-width: 1400px;
              margin: 0 auto;
              background: white;
              border-radius: 10px;
              box-shadow: 0 4px 6px rgba(0,0,0,0.1);
              overflow: hidden;
            }
            .navbar {
              background: linear-gradient(45deg, #2196F3, #21CBF3);
              padding: 15px 20px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 3px solid #e3f2fd;
            }
            .logo {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              border: 2px solid white;
              margin-right: 20px;
              ${logoLoadError ? 'background-color: #f0f0f0;' : ''}
            }
            .school-name {
              font-size: 24px;
              font-weight: 600;
              color: white;
              text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
            }
            .report-title {
              text-align: center;
              padding: 15px;
              color: #2196F3;
              font-size: 20px;
              font-weight: 500;
              background-color: #e3f2fd;
              margin: 0;
              margin-left: -50px;
            }
            .table-container {
              margin: 20px;
              overflow-x: auto;
              max-width: 100%;
            }
            table {
              width: 100%;
              min-width: 1200px;
              border-collapse: separate;
              border-spacing: 0;
            }
            th {
              background: linear-gradient(45deg, #1976D2, #42A5F5);
              color: white;
              padding: 12px 15px;
              font-weight: 600;
              text-transform: uppercase;
              font-size: 13px;
              letter-spacing: 0.5px;
              border-bottom: 2px solid #e3f2fd;
              white-space: nowrap;
              position: sticky;
              top: 0;
              z-index: 1;
            }
            td {
              padding: 12px 15px;
              border-bottom: 1px solid #eee;
              font-size: 13px;
              color: #444;
              white-space: nowrap;
            }
            tr:nth-child(even) {
              background-color: #fafafa;
            }
            tr:hover {
              background-color: #e3f2fd;
              transition: background-color 0.2s ease;
            }
            .print-button {
              background: linear-gradient(45deg, #4CAF50, #66BB6A);
              border: none;
              color: white;
              padding: 12px 24px;
              border-radius: 25px;
              font-size: 14px;
              cursor: pointer;
              box-shadow: 0 2px 4px rgba(0,0,0,0.2);
              transition: all 0.3s ease;
              display: flex;
              align-items: center;
              margin-bottom: 10px;
            }
            .print-button:hover {
              background: linear-gradient(45deg, #45a049, #5daf53);
              transform: translateY(-2px);
              box-shadow: 0 4px 8px rgba(0,0,0,0.3);
            }
            .print-icon {
              margin-right: 8px;
              font-size: 18px;
            }
            .amount {
              text-align: right;
            }
            .student-name {
              width: 20%;
              min-width: 200px;
            }
            .admission-no {
              width: 10%;
              min-width: 100px;
            }
            .roll-no {
              width: 6%;
              min-width: 60px;
            }
            .payment-date {
              width: 10%;
              min-width: 100px;
            }
            .total-fee {
              width: 8%;
              min-width: 80px;
            }
            .paid-amount {
              width: 8%;
              min-width: 80px;
            }
            .balance {
              width: 8%;
              min-width: 80px;
            }
            .fine {
              width: 6%;
              min-width: 60px;
            }
            .receipt-no {
              width: 8%;
              min-width: 80px;
            }
            .month {
              width: 6%;
              min-width: 60px;
            }
            .class {
              width: 6%;
              min-width: 60px;
            }
            .section {
              width: 6%;
              min-width: 60px;
            }
            .payment-mode {
              width: 8%;
              min-width: 80px;
            }
            .session {
              width: 6%;
              min-width: 60px;
            }
            @media print {
              .print-button {
                display: none;
              }
              body {
                margin: 0;
                background: white;
              }
              .form-container {
                box-shadow: none;
              }
              .table-container {
                overflow-x: visible;
              }
              table {
                min-width: 0;
              }
            }
          </style>
        </head>
        <body>
          <div class="form-container">
            ${schoolData
          .map(
            (item) => `
                <div class="navbar">
<img class="logo" src="${logoDataUrl}" alt="Logo" />
                  <div class="school-name">${item.schoolName}</div>
                  <button class="print-button" onclick="window.print()">
                    <span class="print-icon">🖨️</span> Print Report
                  </button>
                </div>
              `
          )
          .join("")}
            <div class="report-title">Fee Payment Report (${formattedFromDate} - ${formattedToDate})</div>
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th class="student-name">Student Name</th>
                    <th class="admission-no">Admission No</th>
                    <th class="roll-no">Roll No</th>
                    <th class="payment-date">Payment Date</th>
                    <th class="total-fee amount">Total Fee</th>
                    <th class="paid-amount amount">Paid Amount</th>
                    <th class="balance amount">Balance</th>
                    <th class="fine amount">Fine</th>
                    <th class="receipt-no">Receipt No</th>
                    <th class="month">Month</th>
                    <th class="class">Class</th>
                    <th class="section">Section</th>
                    <th class="payment-mode">Payment Mode</th>
                    <th class="session">Session</th>
                  </tr>
                </thead>
                <tbody>
                  ${data
          .map(
            (item) => `
                      <tr>
                        <td class="student-name">${item.studentName || "-"}</td>
                        <td class="admission-no">${item.admissionNo || "-"}</td>
                        <td class="roll-no">${item.rollNo || "-"}</td>
                        <td class="payment-date">${item.feePaymentDate || "-"}</td>
                        <td class="total-fee amount">₹${(item.totalFee || 0).toFixed(2)}</td>
                        <td class="paid-amount amount">₹${(item.paidAmount || 0).toFixed(2)}</td>
                        <td class="balance amount">₹${(item.balanceAmount || 0).toFixed(2)}</td>
                        <td class="fine amount">₹${(item.fineAmount || 0).toFixed(2)}</td>
                        <td class="receipt-no">${item.recieptNo || "-"}</td>
                        <td class="month">${item.monthName || "-"}</td>
                        <td class="class">${item.className || "-"}</td>
                        <td class="section">${item.sectionName || "-"}</td>
                        <td class="payment-mode">${item.paymentMode || "-"}</td>
                        <td class="session">${item.session || "-"}</td>
                      </tr>
                    `
          )
          .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </body>
      </html>
    `);
    } catch (error) {
      console.error("Error fetching report data:", error);
    }
  };

  const generateCSV = () => {
    if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
      console.error("No report data available");
      return;
    }

    const headers = [
      "Student Name",
      "Admission No",
      "Roll No",
      "Payment Date",
      "Total Fee",
      "Paid Amount",
      "Balance Amount",
      "Fine Amount",
      "Receipt No",
      "Month",
      "Class",
      "Section",
      "Payment Mode",
      "Session",
    ];

    const csvContent = [
      headers.join(","),
      ...reportData.map((item) =>
        [
          item.studentName || "-",
          item.admissionNo || "-",
          item.rollNo || "-",
          item.feePaymentDate || "-",
          item.totalFee || 0,
          item.paidAmount || 0,
          item.balanceAmount || 0,
          item.fineAmount || 0,
          item.recieptNo || "-",
          item.monthName || "-",
          item.className || "-",
          item.sectionName || "-",
          item.paymentMode || "-",
          item.session || "-",
        ].join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
    saveAs(
      blob,
      `fee_payment_report_${new Date().toISOString().split("T")[0]}.csv`
    );
  };

  const buttonStyles = {
    generate: {
      background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
      borderRadius: "25px",
      padding: "10px 25px",
      width: "150px",
      boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "linear-gradient(45deg, #1976D2 30%, #1E88E5 90%)",
        transform: "translateY(-2px)",
        boxShadow: "0 5px 10px rgba(33, 203, 243, .4)",
      },
    },
    csv: {
      background: "linear-gradient(45deg, #f44336 30%, #ef5350 90%)",
      borderRadius: "25px",
      padding: "10px 25px",
      width: "150px",
      boxShadow: "0 3px 5px 2px rgba(244, 67, 54, .3)",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "linear-gradient(45deg, #d32f2f 30%, #e53935 90%)",
        transform: "translateY(-2px)",
        boxShadow: "0 5px 10px rgba(244, 67, 54, .4)",
      },
    },
  };

  // Styled to match GenerateFee's select styling
  const selectStyles = {
    width: "250px",
    borderRadius: "10px",
    background: "#ffffff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.07)",
    transition: "box-shadow 0.2s ease",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2196F3",
      borderWidth: "1.5px",
    },
    "&:hover": {
      boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" },
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#21CBF3",
      borderWidth: "2px",
    },
    "&.Mui-disabled": { opacity: 0.55 },
    "& .MuiSelect-select": {
      padding: "11px 16px",
      fontWeight: 500,
      color: "#333",
      fontSize: "0.875rem",
    },
  };

  const menuProps = {
    PaperProps: {
      sx: {
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        mt: 0.5,
        "& .MuiMenuItem-root": {
          fontSize: "0.875rem",
          "&:hover": { backgroundColor: "#e3f2fd" },
          "&.Mui-selected": {
            backgroundColor: "#e3f2fd",
            "&:hover": { backgroundColor: "#bbdefb" },
          },
        },
      },
    },
  };

  const fieldLabelSx = {
    display: "block",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#546e7a",
    mb: 0.6,
    letterSpacing: "0.03em",
  };

 return (
    <div>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        sx={{ padding: "20px" }}
      >
        {isMaster && (
          <FormControl style={{ marginBottom: "20px" }}>
            <Typography component="label" sx={fieldLabelSx}>Branch</Typography>
            <Select
              value={selectedBranchId || ""}
              onChange={(e) => setSelectedBranchId(e.target.value)}
              displayEmpty
              sx={selectStyles}
              MenuProps={menuProps}
            >
              <MenuItem value="" disabled>
                <em>Select Branch</em>
              </MenuItem>
              {branches.map((branch) => (
                <MenuItem key={branch.branchId} value={branch.branchId}>
                  {branch.branchName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <FormControl style={{ marginBottom: "20px" }}>
          <Typography component="label" sx={fieldLabelSx}>Class Type</Typography>
          <Select
            value={selectedClassType}
            onChange={handleClassTypeDropdownChange}
            displayEmpty
            sx={selectStyles}
            MenuProps={menuProps}
          >
            <MenuItem value="">
              <em>All Classes</em>
            </MenuItem>
            {ddlClassType.map((typeItem) => (
              <MenuItem key={typeItem.classTypeId} value={typeItem.classTypeId}>
                {typeItem.classType}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl component="fieldset" style={{ marginBottom: "20px" }}>
          <RadioGroup
            aria-label="classType"
            value={classType}
            onChange={handleClassTypeChange}
          >
            <Box display="flex">
              <FormControlLabel
                value="allclass"
                control={<Radio />}
                label="All Class"
              />
              <FormControlLabel
                value="classWiseStudent"
                control={<Radio />}
                label="Class Wise Student"
              />
            </Box>
          </RadioGroup>
        </FormControl>

        {classType === "classWiseStudent" && (
          <FormControl style={{ marginBottom: "20px" }}>
            <Typography component="label" sx={fieldLabelSx}>Class</Typography>
            <Select
              value={selectedClass}
              onChange={handleClassChange}
              displayEmpty
              sx={{ ...selectStyles, minWidth: "200px" }}
              MenuProps={menuProps}
            >
              <MenuItem value="" disabled>
                Select Class
              </MenuItem>
              {ddlClass.map((classItem) => (
                <MenuItem key={classItem.classId} value={classItem.classId}>
                  {classItem.className}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <FormControl component="fieldset" style={{ marginBottom: "20px" }}>
          <RadioGroup
            aria-label="sectionType"
            value={sectionType}
            onChange={handleSectionTypeChange}
          >
            <Box display="flex">
              <FormControlLabel
                value="allSection"
                control={<Radio />}
                label="All Section"
              />
              <FormControlLabel
                value="selectSection"
                control={<Radio />}
                label="Select Section"
              />
            </Box>
          </RadioGroup>
        </FormControl>

        {sectionType === "selectSection" && (
          <FormControl style={{ marginBottom: "20px" }}>
            <Typography component="label" sx={fieldLabelSx}>Section</Typography>
            <Tooltip title={!selectedClass ? "Select a class first" : ""} placement="top">
              <Select
                value={selectedSection}
                onChange={handleSectionChange}
                displayEmpty
                disabled={!selectedClass}
                sx={{ ...selectStyles, minWidth: "200px" }}
                MenuProps={menuProps}
              >
                <MenuItem value="" disabled>
                  Select Section
                </MenuItem>
                {ddlSection.map((sectionItem) => (
                  <MenuItem
                    key={sectionItem.sectionId}
                    value={sectionItem.sectionId}
                  >
                    {sectionItem.sectionName}
                  </MenuItem>
                ))}
              </Select>
            </Tooltip>
          </FormControl>
        )}

        <FormControl component="fieldset" style={{ marginBottom: "20px" }}>
          <RadioGroup
            aria-label="studentType"
            value={studentType}
            onChange={handleStudentTypeChange}
          >
            <Box display="flex">
              <FormControlLabel
                value="allStudent"
                control={<Radio />}
                label="All Student"
              />
              <FormControlLabel
                value="selectStudent"
                control={<Radio />}
                label="Select Student"
              />
            </Box>
          </RadioGroup>
        </FormControl>

        {studentType === "selectStudent" && (
          <FormControl style={{ marginBottom: "20px" }}>
            <Typography component="label" sx={fieldLabelSx}>Student</Typography>
            <Tooltip title={!selectedClass ? "Select a class first" : ""} placement="top">
              <Select
                value={selectedStudent}
                onChange={handleStudentChange}
                displayEmpty
                disabled={!selectedClass}
                sx={{ ...selectStyles, minWidth: "200px" }}
                MenuProps={menuProps}
              >
                <MenuItem value="" disabled>
                  Select Student
                </MenuItem>
                {ddlStudent.map((studentItem) => (
                  <MenuItem
                    key={studentItem.studentId}
                    value={studentItem.studentId}
                  >
                    {studentItem.studentName}
                  </MenuItem>
                ))}
              </Select>
            </Tooltip>
          </FormControl>
        )}

        <Box display="flex" alignItems="center" gap={2}>
          <TextField
            id="fromDate"
            label="From Date"
            type="date"
            value={fromDate}
            onChange={handleFromDateChange}
            InputLabelProps={{ shrink: true }}
            sx={{ width: "200px" }}
          />
          <TextField
            id="toDate"
            label="To Date"
            type="date"
            value={toDate}
            onChange={handleToDateChange}
            InputLabelProps={{ shrink: true }}
            sx={{ width: "200px" }}
          />
          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              onClick={generateReport}
              sx={buttonStyles.generate}
            >
              Fee Deposit Report
            </Button>
            <Button
              variant="contained"
              onClick={generateCSV}
              sx={buttonStyles.csv}
            >
              Download CSV
            </Button>
          </Box>
        </Box>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="error" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </div>
  );
};

export default DepositFee;